// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"TopLandingsReport_contentComponent__3YT5n","tableContainer":"TopLandingsReport_tableContainer__32TSw","totalRow":"TopLandingsReport_totalRow__b4H8a"};